import { useQuery } from '@tanstack/react-query'
import { workerKeys } from './keys'
import { getWorkerCompliments } from 'api/worker'

export function useWorkerCompliments(workerId: number) {
  return useQuery({
    queryKey: workerKeys.compliments(workerId),
    queryFn: () => getWorkerCompliments(workerId),
  })
}
